
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#464646","d":"M6.802 12.611h9.951a2.437 2.437 0 002.358 1.833 2.444 2.444 0 100-4.888 2.44 2.44 0 00-2.358 1.833h-9.95l-.016-.049 10.589-6.175a2.444 2.444 0 10-.709-1.72c0 .23.041.448.101.66L6.18 10.28a2.445 2.445 0 10-1.736 4.164c.68 0 1.294-.277 1.736-.724l10.588 6.176a2.41 2.41 0 00-.101.66 2.445 2.445 0 10.709-1.72L6.787 12.66l.015-.049"}})])])
          )
        }
      }
    